import React, {Component} from "react";
import ScrollContainer from 'react-indiana-drag-scroll'

class PayrollTable extends Component {
  /**
   * Initializes payroll table state from input dataset.
   * @param {Object} props - React props containing payroll dataset.
   * @return {void} No return value.
   */
  constructor(props){
    super(props);
    this.state = {
      dataSet: this.props.dataSet,
      admin:[],
      office:[]
    }
  }

  /**
   * Renders a payroll header column cell.
   * @param {{value: string}} col - Column descriptor.
   * @param {number} index - Column index.
   * @return {JSX.Element} Header cell element.
   */
  renderColumns = (col, index) => {
    // console.log('col is ', col);
    return (<th key={index} style={{ textAlign:"center"} } >{col.value}</th>);
  }

  /**
   * Renders a payroll data row.
   * @param {Array} row - Data cells for a row.
   * @param {number} index - Row index.
   * @return {JSX.Element} Table row element.
   */
  renderRow = (row, index) => {
    // console.log('row', row);
    return <tr key={index}>{row.map(this.renderCell)}</tr>
  }

  /**
   * Renders one payroll cell with negative value highlighting.
   * @param {{value: string|number}} cell - Cell value object.
   * @param {number} index - Cell index.
   * @return {JSX.Element} Table cell element.
   */
  renderCell = (cell, index) => {
    // console.log('cell', cell);
    if(String(cell.value).startsWith('-')){
      return <td key={index} align="right" className="red">{cell.value}</td>
    }
    else{
      return <td key={index} align="right">{cell.value}</td>
    }
  }

  /**
   * Renders a full table header row.
   * @param {Array} title - Header cell descriptors.
   * @return {JSX.Element} Header row element.
   */
  renderTitle(title){
    return <tr>{title.map(this.renderColumns)}</tr>

  }

  /**
   * Renders all rows for a payroll section.
   * @param {Array<Array>} data - Row collection for a section.
   * @return {JSX.Element[]} Rendered rows.
   */
  renderTable(data){
    return data.map(this.renderRow);
  }

  /**
   * Renders payroll report table or empty-state message.
   * @param {Object} props - Component props.
   * @param {Array} props.dataSet - Payroll data sections.
   * @return {JSX.Element} Payroll table UI or empty-state container.
   */
  render(){
    const dataSet = this.props.dataSet;
    // const type = this.props.type;
    // console.log(dataSet);
    // console.log(type);


    if (dataSet.length === 0){
      return (
        <div className="container-fluid report">
          <div className="table-container">
            <div>No payroll data available</div>
          </div>
        </div>
      );
    }

    if (dataSet.length !== 0){
      var title = dataSet[0].data;
      var admin_title = dataSet[2].data;
      var admin_col = dataSet[3].data[0];
      var admin = dataSet[4].data;
      var ministry_title = dataSet[6].data;
      var ministry_col = dataSet[7].data[0];
      var ministry = dataSet[8].data;

      // console.log('title', title);
      // console.log('admin_title', admin_title);
      // console.log('admin_col', admin_col);
      // console.log('admin', admin);
      // console.log('ministry_title', ministry_title);
      // console.log('ministry_col', ministry_col);
      // console.log('ministry', ministry);

    }

    return (<div>
        <div className = "container-fluid report">
          <div className = "table-container">
          <ScrollContainer className="scroll-container">

            <form>
              <table className="table table-striped table-hover">
                <thead>
                  <tr className="title" >
                    <th colSpan='18'> {title[0][0].value}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr></tr>
                  <tr>
                    <th colSpan = '5'> {admin_title[0][0].value}</th>
                    <th colSpan = '4'  style={{ textAlign:"center", 'borderBottom':'1px solid black'} } > {admin_title[0][5].value}</th>
                    <th colSpan = '2'> </th>
                    <th colSpan = '2' style={{ textAlign:"center", 'borderBottom':'1px solid black'} }> {admin_title[0][11].value}</th>
                  </tr>
                  {this.renderTitle(admin_col)}
                  {this.renderTable(admin)}
                  <tr></tr>
                  <tr>
                    <th colSpan = '5'> {ministry_title[0][0].value}</th>
                    <th colSpan = '4'  style={{ textAlign:"center", 'borderBottom':'1px solid black'} } > {admin_title[0][5].value}</th>
                    <th colSpan = '2'> </th>
                    <th colSpan = '2' style={{ textAlign:"center", 'borderBottom':'1px solid black'} }> {admin_title[0][11].value}</th>
                  </tr>
                  {this.renderTitle(ministry_col)}
                  {this.renderTable(ministry)}
                </tbody>
              </table>
            </form>
            </ScrollContainer>
            
          </div>
        </div>
      </div>);
  }


}

export default PayrollTable;
